<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title>      
                <v-btn icon href="/system-email-template">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>  
                {{ 'System Email Template' | translate }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="9" md="9">
                      <v-row v-if="errors">
                        <v-col cols="12" sm="12" md="12">
                          <v-alert
                            dense
                            v-for="(v, k) in errors"
                            :key="k"
                            outlined
                            type="error"
                          >{{ k }} {{ v }}</v-alert>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            :label="'Template name' | translate"
                            v-model="template_name"
                            name="template_name"
                            autocomplete="off"
                            :rules="templatenameRules"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-select
                            v-model.lazy="template_language"
                            :items="languages"
                            item-value="lang_code"
                            :item-text="item =>`${this.$t(item.lang_name)}`"
                            :label="'Language' | translate"
                            autocomplete="off"
                            name="lang_id"
                            :rules="languagecodeRules"
                            outlined
                            required
                          >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>    
                          </v-select>
                        </v-col>

                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-autocomplete
                              v-model="mail_types"
                              :items="mailtypes"
                              :label="'Select Mail Template' | translate"
                              outlined
                              chips
                              small-chips
                              required
                              :disabled="(template_id? true : false)"
                              :no-data-text="$t('No data available')"
                              @change="mailTypeSelected"
                            >
                            <template #message="{ message }">
                              {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                            </template>  

                            <template v-slot:item="{ item }">
                              <div class="d-flex flex-column"> 
                                <span>{{$t(item)}}</span>
                              </div>
                            </template>

                            </v-autocomplete>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12" md="12" class="mt-n3 pb-4">
                          <h3>{{'Placeholders' | translate}}</h3>
                            <span class="pa-2" v-if="mail_types.length"> {{"Use these placeholders while constructing Email" | translate}} </span>
                            <span class="pa-2" v-else> {{"No placeholders available" | translate}} </span>
                            <div>
                                <v-chip
                                class="ma-2 mb-4"  v-for='(placeholders,index) in mailplaceholders' :key='index'
                                @click="addplaceholder(placeholders)"
                                >
                                {{placeholders}}
                                </v-chip>
                                <span id="custom-tooltip">{{"Copied to Clipboard!" | translate}} </span>
                            </div>
                        </v-col>
                      </v-row>
                       

                      <v-row>
                        <v-col cols="12" sm="12" md="12">
                          <v-text-field
                            outlined
                            :label="'Subject' | translate"
                            v-model="template_subject"
                            name="subject"
                            autocomplete="off"
                            :rules="subjectRules"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                            
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <div class="mb-3 mt-n2 pb-6"> <span class="title">{{ 'Email template' | translate}}</span>
                            <div class="d-flex test-mail-section">
                                <div class="d-flex test-mail-input" v-if="test_mail_input">
                                  <v-text-field dense class="mr-4" v-model="test_email" :label="'Enter Mail' | translate" outlined clearable :rules="emailRules" required></v-text-field>
                                  <v-btn
                                    elevation="2"
                                    small
                                    class="white--text mt-1" :color="primary_color"
                                    @click="sendTestMail"
                                  > {{"Send" | translate}} </v-btn>
                                </div>
                                <div class="text-center d-flex test-mail-button justify-space-around" v-if="test_mail">
                                    <v-btn
                                      elevation="2"
                                      small
                                      class="white--text btn" :color="primary_color"
                                      v-if="template_id && templateEdited"
                                      @click="toggleMailInput"
                                    > {{"Send Test Mail" | translate}}</v-btn>
                                </div>
                            </div>
                            
                          </div>
                            
                            <template>
                                <div id="app">
                                    <tiptap 
                                    v-model="template"
                                    />
                                </div>
                                 <!-- <div class="content">
                                        <h3>Content</h3>
                                        <pre><code>{{ template }}</code></pre>
                                    </div> -->
                            </template>

                        </v-col>
                      </v-row>
                    </v-col>
                    <v-col cols="12" sm="4" md="4"></v-col>
                  </v-row>
                </v-form>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="template_id != ''"
                  @click="submit"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="template_id"
                  @click="update"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-card-text>

                          
            </v-container>
          </v-card>
       </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>  

<script>
import {
  FETCH_EMAIL_TYPES,
  FETCH_MAIL_PLACEHOLDERS,
  FETCH_LANGUAGES,
  FETCH_INDIVIDUAL_MAIL_TEMPLATE,
  SEND_TEST_MAIL, 
  ADD_CUSTOM_MAIL_TEMPLATE,
  UPDATE_CUSTOM_MAIL_TEMPLATE,
  RESET_STATE
} from "@/store/actions.type";
import {  SET_SNACKBAR, SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type"
import tiptap from '@/components/tiptap/tiptap.vue'
import store from "@/store"
import { mapState } from "vuex"
import { mapGetters } from "vuex"
export default {
  name: "addcustomemailtemplate",
  async beforeRouteUpdate(to, from, next) {
    await store.dispatch(RESET_STATE)
    return next();
  },
  async beforeRouteEnter(to, from, next) {
    Promise.all([
        await store.dispatch(FETCH_EMAIL_TYPES,''), 
        await store.dispatch(FETCH_LANGUAGES, ""),
        
    ]).then(() => {
        store.commit(SET_LOADING, false)
      }) 
    if (to.params.id) {
      await store.dispatch(FETCH_INDIVIDUAL_MAIL_TEMPLATE, to.params.id)
      
    }

    store.commit(SET_ROUTER_ENTER, false)

    return next();
  },
  async beforeRouteLeave(to, from, next) {
    await store.dispatch(RESET_STATE)
    next();
  },
  components: { tiptap }, 
  computed: {
    ...mapGetters(['mailtypes','adminusers','languages', 'individualtemplate', 'currentUser', 'curLanguage']),
    ...mapState({
      errors: state => state.groups.grouperrors,
      mailplaceholders: state => state.emailtemplates.mailplaceholders
    }),
    templatenameRules(){  return [v => !!v || "Template name is required"]},
    subjectRules(){  return [v => !!v || "Subject is required"]},
    emailRules(){ 
      return [v => /.+@.+/.test(v) || ""]
    },
    languagecodeRules(){ return [v => !!v || "Company Language is required"]},
  },
  async mounted () {
    if(!this.hasrequiredPermissions()){
      this.$router.push('/dashboard');
    }

    this.test_email = this.currentUser.email;
    this.templateEdited = true;
    this.companymeta = JSON.parse(this.currentUser.company.company_meta);
    this.primary_color  = this.companymeta.primary_color 

    if(Object.keys(this.individualtemplate).length >0){
      this.template_id = this.individualtemplate.id
      this.template_name =   this.individualtemplate.mail_template_name
      this.template_language =   this.individualtemplate.mail_language
      this.template_subject =   this.individualtemplate.subject
      this.mail_types =   this.individualtemplate.mailable
      this.template   =   this.individualtemplate.text_template
    }

    if( this.individualtemplate.mailable){
      //load the necessary apis to load the placeholders
      this.mailTypeSelected();
    }
  },
  data: function() {
    return {
      template_id: null,
      template: null,
      template2: null,
      template_name: null,
      template_language :null,
      template_subject: null,
      mail_types:[],
      part1:null,
      part2:null,
      part3:null,
      button1:null,
      isLoading:false,
      primary_color:null,
      test_mail:true,
      test_mail_input:false,
      test_email:null,
      templateEdited:false,
    }
  },
  watch: {
    // whenever template changes, this function will run
    template(newValue, oldValue) {
      if(oldValue){
        if(newValue !== oldValue){
          this.templateEdited = false;
        }
      }
    }
  },
  methods : {
    hasrequiredPermissions(){
      if(this.currentUser.roles.includes(1) == true || this.currentUser.permissions.includes('has-access-to-system-mails') ){
        return true;
      }
      return false;
    },
    async mailTypeSelected() {
      if(this.mail_types){
        //load apis that will fetch mail placeholders
        await store.dispatch(FETCH_MAIL_PLACEHOLDERS,  'mail-place-holders?mail_type='+this.mail_types).then(resp => {
            if (resp.success) {
                store.commit(SET_LOADING, false);
                this.isLoading = false
            }
        });

      }
    },

    toggleMailInput(){
      this.test_mail = false;
      this.test_mail_input = true;
    },
    sendTestMail(){
      if (this.$refs.form.validate()) {
        let data = {
            mailable: this.mail_types,
            email: this.test_email,
            mail_language: this.template_language,
          }
        
        this.$store
          .dispatch(SEND_TEST_MAIL, data)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'Mail Sent! Please check email'})
              store.commit(SET_LOADING, false)
              this.test_mail = true;
              this.test_mail_input = false;
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    addplaceholder(placeholder) {
        const insertText = placeholder
        if (!insertText.length) return

        navigator.clipboard.writeText(placeholder).then(() => {
          /* clipboard successfully set */
          document.getElementById("custom-tooltip").style.display = "inline";
          setTimeout( function() {
              document.getElementById("custom-tooltip").style.display = "none";
          }, 1000);
        }, () => {
          /* clipboard write failed */
        });
    },
    submit: function() {
      if (this.$refs.form.validate()) {
        let data = {
            mail_template_name: this.template_name,
            mailable: this.mail_types,
            mail_language: this.template_language,
            subject:this.template_subject,
            text_template: this.template,
          }
        
        this.$store
          .dispatch(ADD_CUSTOM_MAIL_TEMPLATE, data)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'Template created successfully'})
              store.commit(SET_LOADING, false)
              this.$router.push("/system-email-template/edit/" + resp.data.id)
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    update: function() {
    //   this.template = this.$refs.contenteditabletextarea.innerHTML;
      if (this.$refs.form.validate()) {

        let data = {
            id: this.template_id,
            mail_template_name: this.template_name,
            mailable: this.mail_types,
            mail_language: this.template_language,
            subject:this.template_subject,
            text_template: this.template,
            _method: "put"
          };

        this.$store
          .dispatch(UPDATE_CUSTOM_MAIL_TEMPLATE, data)
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'Template successfully'})
              store.commit(SET_LOADING, false)
              this.$router.push({ name: "customemailtemplate" })
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    }

  },
};
</script>

<style scoped>
[contenteditable] {
  outline: 0px solid transparent;
}

.btn.disabled {
    pointer-events: auto;
}

.test-mail-section{
  float: right;
}
#custom-tooltip {
    display: none;
    margin-left: 40px;
    padding: 5px 12px;
    background-color: #000000df;
    border-radius: 4px;
    color: #fff;
}
</style>